"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var customIndexedDB = function (name) {
    return {
        store: function (key, value) { return localStorage.setItem(key, value); },
        get: function (key) { return localStorage.getItem(key); },
        eject: function (key) { return localStorage.removeItem(key); }
    };
};
exports.default = customIndexedDB;
